const SET_ACTION_PLAN_HEADER = "SET_ACTION_PLAN_HEADER";

const mutations = {
  [SET_ACTION_PLAN_HEADER](state, hour) {
    state.actionPlanHeader = hour;
  },
};
export default mutations;
